import React, { useContext } from 'react';

import { Dialog, DialogTitle, DialogContent, useDialog } from './Dialog';
import ReturnPolicyText from './ReturnPolicyText';
import { useBrandingData } from './DataProviders';


export default function ReturnPolicyDialog() {
  const { open, toggle } = useReturnPolicyDialog();

  return (
    <Dialog id="return-policy-dialog" toggle={toggle} open={open}>
      <DialogTitle onClose={toggle}>
        Return Policy
      </DialogTitle>

      <DialogContent>
        <ReturnPolicyText />
      </DialogContent>
    </Dialog>
  );
}


const ReturnPolicyDialogContext = React.createContext({ open: false });

export function ReturnPolicyDialogProvider({ children }) {
  const [open, toggle] = useDialog();
  const { toggles: { show_return_policy } } = useBrandingData();

  return <ReturnPolicyDialogContext.Provider value={{ open, toggle }}>
    {children}
    { show_return_policy &&
      <ReturnPolicyDialog />
    }
  </ReturnPolicyDialogContext.Provider>;
}

export function useReturnPolicyDialog() {
  return useContext(ReturnPolicyDialogContext);
}
